export const PERSON_TYPES_REQUEST = 'personTypes/PERSON_TYPES_REQUEST';
export const PERSON_TYPES_SUCCESS = 'personTypes/PERSON_TYPES_SUCCESS';
export const PERSON_TYPES_FAILURE = 'personTypes/PERSON_TYPES_FAILURE';

export const PERSON_TYPES_DICT_REQUEST = 'personTypes/PERSON_TYPES_DICT_REQUEST';
export const PERSON_TYPES_DICT_SUCCESS = 'personTypes/PERSON_TYPES_DICT_SUCCESS';
export const PERSON_TYPES_DICT_FAILURE = 'personTypes/PERSON_TYPES_DICT_FAILURE';
